import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TrialModuleKey, TrialResearchPreview } from '../../types';
import { BrandLogo } from './brand-logo';

type Props = {
  name: string;
  preview: TrialResearchPreview;
  locationsCount: number;
  modules: TrialModuleKey[];
};

/** The right column of the last step: the promise, on a photo, in their colours. */
export const HeroPanel = ({
  name, preview, locationsCount, modules,
}: Props) => {
  const { t } = useTranslation();
  const main = preview.colors?.main ?? '#19214D';
  const chips = [
    ...modules.map((key) => t(`authentication:trial_module_${key}`)),
    t('authentication:trial_details_hero_reports'),
  ];

  return (
    <div className="FreeTrial__Hero">
      <div className="FreeTrial__Hero__Brand">
        <BrandLogo
          iconUrl={preview.icon_url}
          logoUrl={preview.logo_url}
          name={name}
          style={{ backgroundColor: main }}
        />
        <div>
          <h5>{name}</h5>
          <div className="FreeTrial__Hero__Meta">
            {t(`authentication:trial_industry_set_${preview.industry_proposed}`)}
            {' · '}
            {t('authentication:trial_preview_locations_found', { count: locationsCount })}
          </div>
        </div>
      </div>
      <h3>{t('authentication:trial_details_hero_title')}</h3>
      <div className="FreeTrial__Chips">
        {chips.map((chip) => <span key={chip} className="FreeTrial__Chip FreeTrial__Chip--glass">{chip}</span>)}
      </div>
      <div className="FreeTrial__Hero__Note">{t('authentication:trial_details_hero_note')}</div>
    </div>
  );
};
